import React, { useRef } from "react";
import Header from "./Header";
import Explorer from "../Explorer/Explorer";
import Testimonials from "../Testimonials/Testimonials";
import Footer from "../Footter/Footer";
import "./home.css";
import photo1 from "../../images/one.png";
import photo2 from "../../images/two.png";

const Home = () => {
  const HomeRef = useRef();
  const AboutRef = useRef();
  const ExplorerRef = useRef();
  const ReviewRef = useRef();
  const BioRef = useRef();

  const scrollToBio = () => {
    BioRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <>
      <Header about={AboutRef} explorer={ExplorerRef} review={ReviewRef} home={HomeRef} />

      {/* About Section */}
      <section ref={AboutRef} className="About">
        <div className="container row justify-content-between align-items-center g-4">
          <div className="col-lg-7">
            <img src={photo1} alt="photo1" />
          </div>
          <div className="col-lg-5 info">
            <h1>We pride ourselves on making real food from the best ingredients.</h1>
            <p>
              Every dish we serve is crafted with care, using only fresh, natural ingredients.
              From farm to table, our goal is to deliver meals that are as wholesome as they are delicious.
              No shortcuts, no additives—just real, flavorful food made with passion.
            </p>
            <button className="btn" onClick={scrollToBio}>
              Learn More
            </button>
          </div>
        </div>
      </section>

      {/* About Us Section */}
      <section className="aboutus row align-items-center">
        <div className="col-lg-6 info">
          <h1>We make everything by hand with the best possible ingredients.</h1>
          <p>
            Our chefs believe that great taste comes from dedication and detail.
            From kneading our dough to seasoning every sauce, everything is made from scratch in our kitchen.
            We take the time to make every plate perfect — because food should tell a story.
          </p>
          <div className="liFont"><i className="bi bi-check-lg me-3"></i> Freshly prepared meals every day.</div>
          <div className="liFont"><i className="bi bi-check-lg me-3"></i> Locally sourced ingredients and organic produce.</div>
          <div className="liFont"><i className="bi bi-check-lg me-3"></i> No frozen food, no artificial flavors — ever.</div>
        </div>
        <div className="col-lg-6">
          <img src={photo2} alt="photo2" />
        </div>
      </section>

      {/* Biography Section */}
      <section ref={BioRef} className="Biography text-center">
        <div className="overlay row justify-content-center align-items-center">
          <div className="col-lg-6 text-white d-flex flex-column align-items-start">
            <h2>Our Story</h2>
            <p>
              It all started with a simple idea — to bring people together through good food.
              What began as a small kitchen dream soon grew into a community favorite.
              Every recipe we create is inspired by tradition, perfected with experience,
              and served with love. Because at our place, food is more than a meal — it's a memory.
            </p>
          </div>
        </div>
      </section>

      <Explorer forwardref={ExplorerRef} />
      <Testimonials Reviewref={ReviewRef} />
      <Footer />
    </>
  );
};

export default Home;



